import { render, staticRenderFns } from "./ModalStartTest.vue?vue&type=template&id=4fa9309b"
import script from "./ModalStartTest.vue?vue&type=script&lang=ts"
export * from "./ModalStartTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports